import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { db } from "../firebase-config";
import { doc, getDoc } from "firebase/firestore";
import AnimatedHero from "../Components/AnimatedHero";
import Loader from "../Components/Loader";

const ServiceDetails = () => {
  const { id } = useParams();
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchService = async () => {
      try {
        setLoading(true);
        const docRef = doc(db, "services", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setService(docSnap.data());
        } else {
          setService(null);
        }
      } catch (err) {
        console.error("Error fetching service:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchService();
  }, [id]);

  if (loading)
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <Loader />
      </div>
    );

  if (!service)
    return <p className="text-center py-5">Service not found.</p>;

  return (
    <div>

      {/* Hero Section (Untouched) */}
      <AnimatedHero
        title={service.title}
        className="about-hero"
        overlayColor="rgba(14,77,109,0.15)"
      />

      {/* Main Content Section */}
      <div className="container my-5">

        <Link to="/services" className="btn-primary mb-4">
          ← Back to Services
        </Link>

        <div className="card shadow-sm p-4">
          {service.imageUrl && (
            <img 
              src={service.imageUrl} 
              alt={service.title} 
              className="img-fluid rounded mb-4"
              style={{ maxHeight: "300px", objectFit: "cover", width: "100%" }} 
            />
          )}

          <div className="service-description" style={{ lineHeight: "1.8", fontSize: "1.1rem", color: "#333" }}
               dangerouslySetInnerHTML={{ __html: service.description || "No description available." }} />
        </div>

      </div>

    </div>
  );
};

export default ServiceDetails;
